export enum ILSContractState {
  Pending = 'pending', // ожидает подписания (договор подготовлен, ожидается подписание заявителем)
  Canceled = 'canceled', // отменён (клиент отказался или не подписал договор вовремя)
  Signed = 'signed', // подписан (договор заявителем подписан, ожидается перевод денежных средств заявителю)
  Actual = 'actual', // действует (договор вступил в силу, денежные средства заявителю переведены)
  Closed = 'closed', // закрыт (договор исполнен)
  Sold = 'sold', // продан (договор передан 3-м лицам)
}
